module.exports = __webpack_public_path__ + "img/titleB.5a32a592.png";